export const buildODataQueryString = (params: { [key: string]: any }): string => {
    const queryParts: string[] = [];
  
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryParts.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
  
    return queryParts.length ? `?${queryParts.join('&')}` : '';
  };